import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      overflowX: 'hidden',
    },
  },
  spacer: {
    display: 'block',
    height: theme.spacing(8),
    [theme.breakpoints.up('sm')]: {
      ...theme.mixins.toolbar,
    },
  },
  content: {
    padding: 0,
    flexGrow: 1,

    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1.7, 5.25, 2.5),
      overflow: 'auto',
    },
  },
}))

export default useStyles
